const checkIfItemIsFree = (tickets) => {
  if (!tickets || !Array.isArray(tickets)) return false;
  if (tickets.length === 0) return true;
  const isItemFree = tickets.every(ticket => ticket.price === 0);
  return isItemFree;
};

export default checkIfItemIsFree;
